import client from '../client';

/**
 * Get all the sellers from the API.
 * 
 * @returns {Array} with objects with `{id, name}`.
 */
function get() {
  return client.get('/sellers').then(({ data }) => data)
}

export default {
  get
}
